<template>
  <div>
    <div
      class="productInfo"
      v-for="(item, index) in dataList"
      :key="index"
      @click="toDetail(item.barCode)"
    >
      <div class="container">
        <div class="head">
          <i class="iconfont">&#xe870;</i
          ><span style="color: red">{{ item.barCode }}</span>
        </div>
        <div class="line"></div>
        <div class="content">
          <div class="title">
            <div>实际称重</div>
            <div>参考称重</div>
            <div>总件重</div>
          </div>
          <div class="value">
            <div>{{ item.withCodeWeight + "g" }}</div>
            <div>{{ item.referenceWeight + "g" }}</div>
            <div>{{ item.weight + "g" }}</div>
          </div>
        </div>
        <div class="footer">
          <div style="color: red">货品名称</div>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    toDetail(param) {
      this.$router.push({ path: "/productDetail", query: { barCode: param } });
    },
  },
};
</script>

<style lang="less" scoped>
.productInfo {
  padding: 0 15px;
  margin-bottom: 20px;
}
.container {
  height: 220px;
  border: 1px solid #c3c3c3;
}
.head {
  display: flex;
  align-items: center;
  height: 80px;
}
.line {
  height: 2px;
  background: #c3c3c3;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 90px;
}
.title {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
.title > div {
  color: red;
  width: 33%;
}
.value {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
.value > div {
  width: 33%;
}
.footer {
  margin-left: 50px;
  display: flex;
  height: 50px;
  align-items: center;
}
.footer > div {
  width: 200px;
  height: 100%;
  line-height: 50px;
}
.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@font-face {
  font-family: "iconfont"; /* Project id 3391031 */
  src: url("//at.alicdn.com/t/font_3391031_ximl5221mih.woff2?t=1652186528903")
      format("woff2"),
    url("//at.alicdn.com/t/font_3391031_ximl5221mih.woff?t=1652186528903")
      format("woff"),
    url("//at.alicdn.com/t/font_3391031_ximl5221mih.ttf?t=1652186528903")
      format("truetype");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 40px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
</style>
